export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./filter.vue?vue&type=template&id=a54d5e3a&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/filter/filter.vue?vue&type=template&id=a54d5e3a&
// module id = 1168
// module chunks = 0